import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusMovieList from 'components/list/movieList/movieListFocus.js';
import UniversalMovieList from 'components/list/movieList/movieListUniversal.js';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieList {...props} />;
	return <UniversalMovieList {...props} />;
};